import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useGeoStore = defineStore('geoStore', function () {
  const geoData = ref(null)
  const geoLoading = ref(true)

  async function getGeoData() {
    // Disabled: ipapi.co blocks cross-origin requests from production (CORS).
    // import axios from 'axios'
    // const response = await axios.get('https://ipapi.co/json/')
    // geoData.value = response.data
    geoData.value = null
    geoLoading.value = false
  }

  return { getGeoData, geoData, geoLoading }
})
